import { TextField } from '@mui/material'

export const Details = ({handlerChange, form}) => {
    const inputs = form.data
    return (
        <TextField label="Poster Name" size='small' name="poster_name" onChange={handlerChange} 
            value={inputs.poster_name}
            error={inputs.error && inputs.poster_name.trim() === ""}
        />
    )
}
